module.exports = __webpack_public_path__ + "media/Loops 90 Perc.01eeef7e.wav";